<template>
  <div class="form-section mb-0">
    <div class="row">

      <div class="col-md-6">
        <div class="form-group d-flex align-items-center">
          <label class="mb-0 mr-3">Tiene EPS</label>
          <b-form-checkbox
            v-model="form.hasEps"
            name="hasEps"
            switch
            size="lg"
          />
        </div>
      </div>

      <div class="col-md-6" v-if="form.hasEps">
        <div class="form-group">
          <label>Entidad EPS</label>
          <input
            type="text"
            v-model="form.epsEntity"
            autocomplete="off"
            placeholder="Ingresar entidad EPS"
            class="custom-form-control"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group d-flex align-items-center">
          <label class="mb-0 mr-3">SCTR Pensión</label>
          <b-form-checkbox
            v-model="form.hasSctrPension"
            name="hasSctrPension"
            switch
            size="lg"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group d-flex align-items-center">
          <label class="mb-0 mr-3">SCTR Salud</label>
          <b-form-checkbox
            v-model="form.hasSctrHealth"
            name="hasSctrHealth"
            switch
            size="lg"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group d-flex align-items-center">
          <label class="mb-0 mr-3">Seguro de vida ley</label>
          <b-form-checkbox
            v-model="form.hasLifeInsurance"
            name="hasLifeInsurance"
            switch
            size="lg"
          />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Código EsSalud</label>
          <input
            type="text"
            v-model="form.essaludCode"
            autocomplete="off"
            placeholder="Ingresar código EsSalud"
            class="custom-form-control"
          />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    form: { type: Object, required: true },
    v:    { type: Object, required: true },
  },
}
</script>

<style lang="stylus" scoped></style>
